import store from '../store';
import CampaignModel from '../models/CampaignModel';

export default class Campaign {
  constructor(api) {
    this.api = api
  }

  list() {
    this.api.call_busy({
      '_class': 'Campaign',
      '_method': 'list',
    }).then(response => {
      // TODO: validation
      let campaigns = response
      campaigns = campaigns.campaign
        ? (
          campaigns.campaign.length
            ? campaigns.campaign.map(a => a._attributes)
            : [campaigns.campaign._attributes]
        )
        : []
      store.commit('setCampaigns', campaigns)
    })
  }


  list_entries() {
    this.api.call_busy({
      '_class': 'Campaign',
      '_method': 'list_entries',
    }).then(res => {
      // TODO: validation
      let campaign_entries = {events: [], mailings: []}
      campaign_entries.events = res.campaign_action
        ? (
          res.campaign_action.length
            ? res.campaign_action.map(a => a._attributes)
            : [res.campaign_action._attributes]
        )
        : []
      campaign_entries.mailings = res.mailing
        ? (
          res.mailing.length
            ? res.mailing.map(a => a._attributes)
            : [res.mailing._attributes]
        )
        : []
      delete campaign_entries._attributes
      store.commit('setCampaignEntries', campaign_entries)
    })
  }
  
  load(campaign_id) {
    if (campaign_id === 'new') {
      return new Promise ((resolve) => {
        const model = new CampaignModel()
        const dt = new Date()
        const range = {
          start: dt.toISOString().substr(0, 10),
          end: dt.toISOString().substr(0, 10)
        }
        model.start_date = range.start.replace(/-/g, '') + '00:00:00'
        model.end_date = range.end.replace(/-/g, '') + '23:59:59'
        store.commit('setActiveCampaign',model)
        resolve(model)
      })      
    } else {
      return this.api.call_busy({
        '_class': 'Campaign',
        '_method': 'load',
        'campaign_id': campaign_id,
      }).then(response => {
        let campaign = response.campaign._attributes
        campaign.own = (response.campaign._attributes.user_id == response._attributes.user_id)
        
        store.commit('setActiveCampaign', campaign)
        return campaign
      })
    }
  }

  create(folder=null) {
    const activeCampaign = store.getters.activeCampaign
    const data = {
      '_class': 'Campaign',
      '_method': 'create',
      'name': activeCampaign.name,
      'start_date': activeCampaign.start_date,
      'end_date': activeCampaign.end_date,
    }
    if (folder && folder.id) {
      data.parent_id = folder.id
    }
    return this.api.call_busy(data).then(response => {
      activeCampaign.own = true
      activeCampaign.campaign_id = response.campaign.campaign_id
      store.commit('setActiveCampaign', activeCampaign)
    })
  }

  update() {
    const activeCampaign = store.getters.activeCampaign
    return this.api.call_busy({
      '_class': 'Campaign',
      '_method': 'update',
      'campaign_id': activeCampaign.campaign_id,
      'name': activeCampaign.name,
      'start_date': activeCampaign.start_date,
      'end_date': activeCampaign.end_date,
    })
  }

}